module.exports = __webpack_public_path__ + "static/media/iud-ec@2x.8d6f851b.jpg";